import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function RecommendationsCard({ recommendations }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Recommended for You</h3>
        <Icon name="SparklesIcon" size={24} className="text-accent" />
      </div>
      <div className="space-y-4">
        {recommendations?.map((item) => (
          <div key={item?.id} className="flex items-start space-x-3 p-3 bg-surface rounded-lg hover:bg-surface/80 contemplative-transition cursor-pointer">
            <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden">
              <AppImage 
                src={item?.image} 
                alt={item?.alt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-inter font-medium text-foreground mb-1">{item?.title}</h4>
              <p className="text-xs font-inter text-muted-foreground mb-2">{item?.description}</p>
              <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                <span className="flex items-center space-x-1">
                  <Icon name="ClockIcon" size={12} />
                  <span>{item?.duration}</span>
                </span>
                <span className="flex items-center space-x-1">
                  <Icon name="TagIcon" size={12} />
                  <span>{item?.category}</span>
                </span>
              </div>
            </div>
            <Icon name="ChevronRightIcon" size={16} className="text-muted-foreground flex-shrink-0" />
          </div>
        ))}
        
        <button className="w-full mt-4 px-4 py-2 border border-accent text-accent rounded-lg font-inter font-medium text-sm hover:bg-accent hover:text-accent-foreground contemplative-transition">
          View More Recommendations
        </button>
      </div>
    </div>
  );
}

RecommendationsCard.propTypes = {
  recommendations: PropTypes?.arrayOf(
    PropTypes?.shape({
      id: PropTypes?.number?.isRequired,
      title: PropTypes?.string?.isRequired,
      description: PropTypes?.string?.isRequired,
      image: PropTypes?.string?.isRequired,
      alt: PropTypes?.string?.isRequired,
      duration: PropTypes?.string?.isRequired,
      category: PropTypes?.string?.isRequired
    })
  )?.isRequired
};